import React from 'react';
import autobind from 'autobind-decorator';

import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";

export class ActivityFeedFilterViewer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: []
        };
    }

    componentDidMount() {
        ActivityFeedFilterService.Get()
            .then((x) => this.setState({filters: x.result}));
    }

    @autobind
    getTitle() {
        if(this.state.filters.length) {
            let item = this.state.filters.find((x) => x.activityFeedFilterId == this.props.ActivityFeedFilterId);

            if(item) {
                return item.name;
            }

            return "All";
        }
        return "";
    }

    render() {
        let title = this.getTitle();

        return <p>{title}</p>;
    }
}


